import { render, staticRenderFns } from "./ClienteFornecedor.vue?vue&type=template&id=42d44ad7&"
import script from "./ClienteFornecedor.vue?vue&type=script&lang=js&"
export * from "./ClienteFornecedor.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ClienteFornecedor.vue?vue&type=style&index=1&id=42d44ad7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports